import { Component, Input, OnInit } from '@angular/core';
import { EVENT } from './../../shared/constants/dali.constants';
import { getValueProperty, setValueProperty } from './../../shared/helpers/functions.helpers';
import { ApplicationService } from './../../shared/services/application/application.service';
import { LinkupService } from './../../shared/services/link-up/linkup.service';
import { BaseComponent } from './../../shared/components/base-component';
import { CopyService } from './../../shared/services/copies/copy.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recaptcha-error',
  templateUrl: './recaptcha-error.component.html',
  styleUrls: ['./recaptcha-error.component.scss']
})
export class RecaptchaErrorComponent extends BaseComponent implements OnInit {

  /**
   * Declaración de la variable headerClass, determina la clase que usara el header
   *
   * *Set class in header*
   *
   * @access              public
   * @type                {string}
   */
  headerClass = '';

  @Input() closeText: string = '';
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() textButton: string = '';

  CONTENT_BOUNDS: any[] | any;

  constructor(
    public app: ApplicationService,
    private readonly _link: LinkupService,
    private readonly cps: CopyService,
    private router: Router
  ) {
    super(app, _link, "recaptcha-error")
  }

  async ngOnInit() {
    this.setHeaderClass();
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy(this.idComponent);
    if (!this.title) {
      this.title = getValueProperty(this.CONTENT_BOUNDS, 'title');
    }

    if (!this.subtitle) {
      this.subtitle = getValueProperty(this.CONTENT_BOUNDS, 'subtitle');
    }

    if (!this.textButton) {
      this.textButton = getValueProperty(this.CONTENT_BOUNDS, 'buttons.primary_button.caption');
    }

    if (!this.icon) {
      this.icon = getValueProperty(this.CONTENT_BOUNDS, 'icon', 'atendimento');
    }
  }

  /**
   * Función para salir de la pantalla actual, si aplica
   *
   * *Function that exits current screen*
   */
  closeApp() {
    let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
    setValueProperty(eventSetting, "label", EVENT.E1customLabel);
    let events = [
      {
        "name": "{EVENT.E1setData.E1transactionName.path}",
        "value": EVENT.E1setData.E1transactionName.value
      }
    ];
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);

    this.router.navigateByUrl("/", { skipLocationChange: true })
      .then(() => {
        console.log(`After navigation:${this.router.url}`)
      });
  }

  setHeaderClass() {
    this.headerClass = 'portal-header';
  }

}
